var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"center":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","id":"403"}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h1',{staticClass:"display-3",attrs:{"xs12":""}},[_vm._v(_vm._s(_vm.$t('forbidden')))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }